export default "__VITE_PUBLIC_ASSET__e24855d4__"